import { Heading } from 'lucide-react';
import type { HeadingBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const headingConfig: BlockTypeConfig<HeadingBlock> = {
  type: 'heading',
  label: 'Heading',
  description: 'Section title with optional subtitle',
  icon: Heading,
  category: 'text',
  createDefault: () => ({
    text: 'New heading',
    level: 'h2',
    alignment: 'left',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.level',
      label: 'Level',
      options: [
        { value: 'h1', label: 'H1' },
        { value: 'h2', label: 'H2' },
        { value: 'h3', label: 'H3' },
        { value: 'h4', label: 'H4' },
      ],
    },
    {
      kind: 'select',
      path: 'data.alignment',
      label: 'Align',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [{ kind: 'text', path: 'data.subtitle', label: 'Subtitle' }],
  variants: [
    {
      id: 'default',
      label: 'Classic',
      thumbnail: '/admin/page-editor/variants/heading-default.svg',
      apply: (d) => ({ ...d, variant: 'default' }),
    },
    {
      id: 'magazine',
      label: 'Magazine',
      thumbnail: '/admin/page-editor/variants/heading-magazine.svg',
      apply: (d) => ({ ...d, variant: 'magazine', alignment: 'left' }),
    },
    {
      id: 'oversized',
      label: 'Oversized',
      thumbnail: '/admin/page-editor/variants/heading-oversized.svg',
      apply: (d) => ({ ...d, variant: 'oversized' }),
    },
    {
      id: 'eyebrow-stacked',
      label: 'Eyebrow stacked',
      thumbnail: '/admin/page-editor/variants/heading-eyebrow-stacked.svg',
      apply: (d) => ({ ...d, variant: 'eyebrow-stacked' }),
    },
  ],
};
